import Vue from 'vue';
export default Vue.extend({
  data: function () {
    return {};
  },
  computed: {
    hasNote() {
      return this.params.data.notes != '' || this.params.data.notes != null;
    },
    noNote() {
      return this.params.data.notes === '' || this.params.data.notes === null;
    },
  },
  beforeMount() {},
  methods: {
    btnClickedHandler(params) {
      this.params.clicked(params.data);
    },
  },
  template: `
    <div>
      <span v-if="hasNote" @click="btnClickedHandler(params)" style="cursor: pointer;">{{ params.data.notes }}</span>
      <span v-if="noNote" @click="btnClickedHandler(params)" class="text-primary fw-semibold fs-5" style="cursor: pointer;">Add notes</span>
    </div>
  `,
});
